import type { PhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';

export const deriveDesignTemplateId = (themeId: string, photoPresentationLayout: PhotoPresentationLayout): string => `${themeId}-${photoPresentationLayout}`;
